import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        mainContentFrame: {
            gridArea: 'main-content',
            minHeight: 0,
            minWidth: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            paddingLeft: 'var(--extra-small-spacing)',
            boxSizing: 'border-box'
        },
        mainContentFrameEmbedded: {
            paddingLeft: 0
        },
        mainContentSurface: {
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            backgroundColor: theme.palette.background.paper
        },
        container: {
            position: 'relative',
            display: 'grid',
            height: '100%',
            minHeight: '100%',
            maxHeight: '100%',
            width: '100%',
            gridTemplateRows: 'auto minmax(0, 1fr)',
            gridTemplateColumns: 'minmax(0px, 1fr)',
            gridTemplateAreas: '"header" "content"',
            rowGap: '1px'
        }
    }
})